import { Field, Widget } from '@kanda-libs/ks-component-ts';
import { Text } from '@kanda-libs/ks-design-library';

import { CirclePoundSterling } from 'lucide-react';

import Expenses from './components/Expenses';
import Incomes from './components/Incomes';
import { CLASS_NAMES, PROPS } from './constants';
import useFinancialInformationFields from './useFinancialInformationFields';

import { YOUR_INFO_CLASS_NAMES } from '../constants';

const FinancialInformationFields: React.FunctionComponent = function () {
  const { onBlur, validation } = useFinancialInformationFields();
  return (
    <>
      <div className="flex flex-col mb-3">
        <div className="flex flex-row gap-x-3 items-center mb-2">
          <CirclePoundSterling size={20} />
          <Text
            className={YOUR_INFO_CLASS_NAMES.title}
            text="Financial Details"
          />
        </div>
        <Text
          className="text-14-22 text-neutral-700 mb-1"
          text="We need some additional financial information, such as other incomes and expenses to those already requested"
        />
        <div className={CLASS_NAMES.header}>
          <Text
            className={CLASS_NAMES.title}
            text="Major Monthly Incomes & Expenses"
          />
        </div>
        <Widget.CreditEmploymentDetailsHouseholdAnnualIncomeAmount
          {...PROPS.householdAnnualIncome}
          validation={validation}
          onBlur={onBlur}
        />
        <Field.NumberInput {...PROPS.monthlyCreditRepayments} />
        <div className="border-b border-neutral-300 mb-4 mt-1" />
        <div className={CLASS_NAMES.header}>
          <Text
            className={CLASS_NAMES.title}
            text="Additional Incomes (optional)"
          />
        </div>
        <Incomes />
        <div className="border-b border-neutral-300 mb-4" />
        <div className={CLASS_NAMES.header}>
          <Text
            className={CLASS_NAMES.title}
            text="Additional Expenses (optional)"
          />
        </div>
        <Expenses />
      </div>
    </>
  );
};

export default FinancialInformationFields;
